//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import HiCell from "../../components/cell/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import { Card } from "vue-stripe-elements-plus";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_PLAN_LIST_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  BEFORE_PAY_PAGE,
  DEVICE,
  PAY_PAGE_TYPE,
  PARAMS,
  PAY_PAGE_TYPE_ID,
  CURRENT_USER_PLAN_LIST,
  CURRENT_USER_INFO,
  PAYPAL_INFO,
} from "../../store/mutation-types";
import { stripePay, paypalUrl, coupon } from "../../services/payment";
import { createPaymentIntent } from "../../apis/payment";
import { showErrorMsg } from "../../utils/error";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { conformCountry } from "../../const/plan";
import paypalComfirm from "../../components/payment/paypal_confirm/Index.vue";
import RichModal from "../../components/login/send_code/RichModal";
import MulConfirm from "../../components/confirm/Mul.vue";

const secrets = {};
const stripe = window.Stripe(process.env.STRIPE_PUBLISHABLE_KEY);
let elements = null;

const initStripePayment = async (id, onComplete) => {
  // 存储 secret 避免重复调用
  const clientSecret = secrets[id] || (await createPaymentIntent(id));
  secrets[id] = clientSecret;

  const appearance = {
    theme: "stripe",
    variables: {
      colorText: "#000000",
    },
  };

  elements = stripe.elements({ appearance, clientSecret });

  const paymentElement = elements.create("payment");
  paymentElement.mount("#payment-element");
  paymentElement.on("change", (event) => {
    if (event.complete) {
      // 表单填写完成，启用 subscribe 按钮
      onComplete();
    }
  });
};

export default {
  name: "PaymentSubscriptionPage",
  components: {
    RichModal,
    HiCell,
    HiHeader,
    Card,
    HiButton,
    paypalComfirm,
    MulConfirm,
  },
  mixins: [validationMixin],
  validations: {
    form: {},
  },
  data() {
    const _this = this;
    return {
      en: false, // 是设备为英语
      interval: null,
      form: {
        id: "",
        name: "",
        discount: null,
        coupon: "", // 优惠吗 2018/12/26
      },
      stripe: {
        publishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
        options: {
          hidePostalCode: true,
        },
      },
      countTime: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      buttons: [
        {
          text: "Remove Code",
          async click() {
            // 清空code
            _this.form.coupon = "";
            _this.form.discount = null;
            return true;
          },
        },
        {
          text: "Help",
          async click() {
            window.open(process.env.CONTACT_US, "_blank");
            return true;
          },
        },
      ],
      cardError: {
        show: false,
        title: "Error",
        message: "",
        buttons: [
          {
            text: "OK",
            click: () => {
              this.cardError.show = false;
            },
          },
          {
            text: "Update Card",
            click: () => {
              this.$router.push({ name: "PaymentBillingPage" });
            },
          },
        ],
      },
      showCouponCancelModal: false,
      promotionalCode: "", // 优惠码弹出code
      promotionalError: "", // 优惠码弹出错误信息
      complete: false,
      backPageNum: -2,
      planName: "",
      filter: "all",
      hideBackBtn: false,
      payType: "stripe",
      promotionalCodeModal: false, // 优惠码输入弹出层
      showPaypalModal: false, // paypal支付弹出层
      showDowngradeMenu: false,
      downgradeTitle: "Confirm Downgrade?",
      downgradeText: "",
      downgradeButtons: [
        {
          text: "Confirm",
          async click() {
            try {
              _this.$loading.show();
              await _this.stripeSubscribeClick();
              return true;
            } catch (e) {
              showErrorMsg(e);
            } finally {
              _this.$loading.hide();
            }
          },
        },
        {
          text: _this.$t("common.contactUs"),
          async click() {
            window.open(process.env.CONTACT_US, "_blank");
            return true;
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
      user: CURRENT_USER_INFO_SIMPLE,
      device: DEVICE,
      params: PARAMS,
      planListOriginal: CURRENT_USER_PLAN_LIST,
      userOriginal: CURRENT_USER_INFO,
      paypalnfo: PAYPAL_INFO,
    }),
    /**
     * 2019.12.14 计算是否显示 “所有价格均为美元”
     */
    showPriceTip() {
      if (this.currentPlanCycle.currency === "USD") {
        return true;
      }
      // palpal支付判断是否是支持的国家，如果不支持或者本身是USD的则显示资源
      if (this.paymentMethod === 2) {
        return !this.currentPlanCycle.payPalSupportCurrency;
      } else {
        return false;
      }
    },
    /**
     * 计算paypal弹出信息
     */
    paypalConfirmInfo() {
      // 2019.12.14 防止出现paypal不支持的币种，所以读取和外层不同的字段
      const info = {
        planName: this.currentPlan.name,
        pricePerMonth: this.currentPlanCycle.pricePerMonth,
        interval: this.currentPlanCycle.interval,
        yearOldPrice: this.currentPlan.billingCycles[1].pricePerMonth,
        hasDiscount: this.hasDiscount,
        payTypeText: this.payTypeText,
        discountPrice: this.discountPrice,
        totalPrice: this.showCurrencyPrice(this.totalPrice),
        discountText: this.discountText,
        payPalSupportCurrency: this.currentPlanCycle.payPalSupportCurrency,
      };
      // 如果不支持paypal则重新计算 部分字段
      if (
        !this.currentPlanCycle.payPalSupportCurrency &&
        this.payType === "paypal"
      ) {
        const price = this.currentPlanCycle.totalUsdPriceNum * this.discount;
        info.pricePerMonth = this.currentPlanCycle.paypalPrePrice;
        info.discountPrice = `${parseFloat(price.toPrecision(12))} ${
          this.currentPlanCycle.payPalCurrency
        }`;
        info.totalPrice = `${this.usdTotalPrice * (1 - this.discount)} ${
          this.currentPlanCycle.payPalCurrency
        }`;
      }
      return info;
    },
    /**
     * 获取支付方式
     */
    paymentMethod() {
      // 2018.11.5 新增通过url直接跳转支付页面，同时以payment_method作为支付方式最高优先级
      if (this.$route.query.payment_method !== undefined) {
        return Number(this.$route.query.payment_method);
      }
      return this.user.paymentMethod;
    },
    /**
     * 是否显示优惠码 2018.12.26
     */
    showCouponBtn() {
      // 如果当前是年付，且曾经输入过优惠码则不显示
      if (this.filter === "year" && this.user.plan.useCoupon) {
        return false;
      }
      // 当前不能为iap模式
      return !this.iapPay;
    },
    iapPay() {
      return this.iap && this.usdTotalPrice <= 400 && this.paymentMethod !== 1;
    },
    /**
     * 2018.9.27
     * 计算是否支持新的支付方式
     */
    iap() {
      // 判断如果此用户上次支付方式是gogle play则认为是iap
      if (this.paymentMethod === 4 || this.paymentMethod === 5) {
        return true;
      }
      // 发现支持该支付方式
      if (this.params && this.params.supportIap === "1") {
        // 判断当前国家是否支持
        const country = conformCountry.find((c) => c === this.params.country);
        // 匹配到符合的国际
        if (country) {
          return true;
        }
      }
      return false;
    },
    /**
     * 计算是否含有优惠
     */
    hasDiscount() {
      if (this.iapPay) {
        return false;
      }
      if (this.user.hasDiscount) {
        return true;
      }
      if (this.form.discount !== null) {
        return this.form.discount;
      }
    },
    /**
     * 计算折扣比例
     */
    discount() {
      if (this.user.hasDiscount) {
        return 0.1;
      }
      if (this.form.discount !== null) {
        return this.form.discount;
      }
      return 0;
    },
    /**
     * 计算折扣文案
     */
    discountText() {
      if (this.user.hasDiscount) {
        return `${this.discount * 100}% Discount for First ${this.payTypeText}`;
      } else {
        return `${this.discount * 100}% Discount`;
      }
    },
    /**
     * 计算当前选中付费项目的类型名称(年 or  月)
     */
    payTypeText() {
      const yearStr = this.$t("myPlanPage.accountInfo.planNextTypeYear");
      const monthStr = this.$t("myPlanPage.accountInfo.planNextTypeMonth");
      if (this.currentPlanCycle.interval === 12) {
        return yearStr;
      } else {
        return monthStr;
      }
    },
    /**
     * 2018.12.26 计算优惠的价格
     */
    discountPrice() {
      const price = this.currentPlanCycle.totalPriceNum * this.discount;
      return this.showCurrencyPrice(parseFloat(price.toPrecision(12)));
    },
    /**
     * 2018.12.26 重新计算折扣后价格
     */
    totalPrice() {
      const price = this.currentPlanCycle.totalPriceNum * (1 - this.discount);
      return parseFloat(price.toPrecision(12));
    },
    /**
     * 2019.12.14 美金的实际支付价格
     */
    usdTotalPrice() {
      const price =
        this.currentPlanCycle.totalUsdPriceNum * (1 - this.discount);
      return parseFloat(price.toPrecision(12));
    },
    /**
     * 年付优惠前价格
     */
    yearOldPrice() {
      const price = this.currentPlan.billingCycles[1].totalPriceNum;
      return parseFloat(price.toPrecision(12));
    },
    /**
     * 2018.10.10 新增
     * 是否在iap模式下价格过高
     */
    iapMoneyMore() {
      return this.iap && this.usdTotalPrice > 400;
    },
    /**
     * 获取当前支付样式 0 全部 1 stripe 2 paypal
     */
    currentPayMethod() {
      if (this.paymentMethod === 6) {
        return 0;
      }
      // 开启iap功能但是要求原来没有支付过，或者之前就是iap支付则进入此逻辑
      if (
        this.iap &&
        (this.paymentMethod === 0 ||
          this.paymentMethod === 4 ||
          this.paymentMethod === 5)
      ) {
        // 当前是iap但是支付金额超出则支付方式变成stripe 和 paypal
        if (this.iapMoneyMore) {
          return 0;
        } else {
          return 1;
        }
      }
      // 2021.5.6 屏蔽paypal显示 所有paypal都显示stripe
      if (this.paymentMethod === 2 || this.paymentMethod === 3) {
        return 2;
      } else {
        return this.paymentMethod;
      }
    },
    /**
     * 获取当前计划
     */
    currentPlan() {
      const plan = this.planList.find((p) => p.name === this.planName);
      if (!plan) {
        console.error("this.$route.params.name", this.planName);
        console.error(
          "planListNames",
          this.planList.map((p) => p.name)
        );
      }
      // 同时默认选中第一个
      return plan;
    },
    /**
     * 当前选中的原始项
     */
    currentOriginalPlan() {
      const plan = this.planListOriginal.find(
        (p) => p.name === this.$route.params.name
      );
      if (plan) {
        const cycle = plan.billing_cycle.find((bc) => bc.id === this.form.id);
        return cycle;
      } else {
        return null;
      }
    },
    /**
     * 获取当前plan 选中cycle信息
     */
    currentPlanCycle() {
      return this.currentPlan.billingCycles.find(
        (bc) => bc.id === this.form.id
      );
    },
  },
  watch: {
    /**
     *  每次打开输入优惠码页面清空输入项和错误信息
     */
    promotionalCodeModal(val) {
      if (val) {
        this.promotionalCode = "";
        this.promotionalError = "";
      }
    },
    "form.id": function (id) {
      // current plan 改变后，重置 payment element，并传递表格填写完成的 callback
      initStripePayment(id, () => {
        this.complete = true;
      });
    },
  },
  activated() {
    // 查看当前设备是否为英语
    this.en = navigator.language.substr(0, 2).toLowerCase() === "en";
    // 重置倒计时
    this.resetTime();
    // 默认选中第一个付费计划
    this.planName = this.$route.params.name;
    // 如果url中指定选中项在直接选中
    this.form.id =
      Number(this.$route.query.plan_id) ||
      Number(this.$route.query.id) ||
      this.currentPlan.billingCycles[0].id;
    // 重置折扣相关信息 2018.12.26 其中discount只是用于显示
    this.form.coupon = "";
    this.form.discount = null;
    this.filter = this.$route.query.filter || "all";
    // 隐藏back按钮
    this.hideBackBtn = this.$route.query.back === "no";
    // 隐藏弹出
    this.showPaypalModal = false;
    this.showCouponCancelModal = false;
    this.promotionalCodeModal = false;
    // 如果该对象存在，说明是通过paypal返回进入该页面，则自动选中之前plan
    if (this.paypalnfo && this.$route.query.plan_id === undefined) {
      const id = this.paypalnfo.id;
      this.form.id = id;
      this.$parent.$refs.payError.show({
        params: { id: this.form.id, sale: true },
      });
    }
  },
  methods: {
    /**
     * 2019.12.14 展示币种价格
     */
    showCurrencyPrice(value) {
      // 美金则把货币符号加载前面
      if (this.currentPlanCycle.currency === "USD") {
        return `$${value}`;
      } else {
        return `${value} ${this.currentPlanCycle.currency}`;
      }
    },
    showCycles(index) {
      if (this.filter === "year") {
        return index === 0;
      }
      const only = this.$route.query.only;
      if (only) {
        // only模式月付用户永远显示所有
        if (this.user.plan.billingInterval === 1) {
          return true;
        }
        // 判断如果是only模式则判断当前是否为年付，如果是则只显示年付
        if (index === 0 && only && this.user.plan.billingInterval === 12) {
          return true;
        }
      } else {
        if (this.filter === "all") {
          return true;
        }
      }
      return false;
    },
    /** stripe订阅 */
    async stripeSubscribeClick() {
      // console.log(this.currentPayMethod)
      // this.currentPayMethod === 0 means the initial pay,
      await stripePay(
        { ...this.form, type: this.$route.query.type },
        this.currentPayMethod === 0,
        stripe,
        elements
      );
      if (this.device === "android") {
        // eslint-disable-next-line
        AndroidWebView.closeWebView(1); // 0 为未进行任何操作
        return;
      }
      this.$toast.show({ message: this.$t("common.success") });
      // The default value of this.backPageNum is -2.
      // If the user is redirected from the app to the Apphi web,
      // the first page is the PlanList and the next page is the Subscription, then -2 is invalid.
      // So we need to check the history length: window.history.length < abs(this.backPageNum) + 1
      if (
        this.$route.query.type === "renew" ||
        this.$route.query.type === "yearly" ||
        this.$route.query.type === "downgrade" ||
        this.$route.query.type === "free2basicpromo" ||
        this.$route.query.only ||
        window.history.length < Math.abs(this.backPageNum) + 1
      ) {
        this.$router.replace({ name: "MyPlanPage" });
      } else {
        this.$router.go(this.backPageNum);
      }
    },
    // 重置倒计时
    resetTime() {
      if (this.interval) {
        return;
      }
      // 时间倒计时 保持倒计时时间介于15分钟到0之间
      this.interval = setInterval(() => {
        // 获取当前时间
        const current = moment();
        // 加15分钟获取一个预估的截止时间
        let endTime = moment();
        // 计算截止时间 如果时间正好卡在整数时间点上则无需处理，如果不是则取下一个节点
        if (endTime.minutes() % 15 === 0 && endTime.seconds() === 0) {
          clearInterval(this.interval);
          this.interval = null;
        } else {
          // 如果处于整数节点则跳到下个节点
          const addMinutes = endTime.minutes() % 15;
          endTime = endTime.add(15 - addMinutes, "minutes").second(0);
        }
        const diffMinutes = endTime.diff(current, "s");
        this.countTime.seconds = Number.parseInt(diffMinutes % 60);
        this.countTime.minutes = Number.parseInt(diffMinutes / 60);
      }, 1000);
    },
    /**
     * 验证优惠码
     */
    async validatePromotionalCode() {
      this.$loading.show();
      try {
        const data = await coupon({ coupon: this.promotionalCode });
        // 折扣
        this.form.discount = data.percentOff;
        this.form.coupon = this.promotionalCode;
        // 关闭弹出层 清空输入框
        this.promotionalCodeModal = false;
      } catch (e) {
        this.promotionalError = e.msg;
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 重写back行为
     */
    overrideBackClick() {
      // 如果来源为支付成功回调则回退到my_plan页
      if (this.$route.query.source === "pay" || this.$route.query.plan_id) {
        this.$router.replace({
          name: "PaymentUpgradePage",
          query: { source: "pay" },
        });
      } else {
        this.$router.go(-1);
      }
    },
    /**
     * subscribe按钮点击事件
     */
    async stripeSubscribe() {
      try {
        this.$loading.show();
        // 开启iap 且价格要小于400 同时原来支付方式不能stripe
        if (this.iapPay) {
          const user = { ...this.currentOriginalPlan };
          let plan = this.userOriginal.subscription.plan;
          if (plan.name === "FREE") {
            plan = null;
          } else {
            if (this.user.purchase_token) {
              plan.purchase_token = this.user.purchase_token;
            }
          }
          console.log("向安卓发送的表单", user, plan, this.user.purchase_token);
          // eslint-disable-next-line
          AndroidWebView.iap(
            JSON.stringify(user),
            plan ? JSON.stringify(plan) : null
          );
        } else {
          // 如果发现是stripe订阅则验证是否为降级操作，如果是则弹出提示信息
          const activeIndex = this.planList.findIndex((i) => i.active);
          const currentPlanIndex = this.planList.findIndex(
            (p) => p.name === this.planName
          );
          // 如果当前选中plan索引比用户当前订阅索引靠后说明是升级操作，直接订阅即可 特殊情况:如果通过url直接降级则不弹出提示信息
          if (
            currentPlanIndex >= activeIndex ||
            this.$route.query.type === "downgrade"
          ) {
            try {
              await this.stripeSubscribeClick();
            } catch (error) {
              // currentPayMethod === 0 表示为输入卡号首次支付
              if (this.currentPayMethod === 0) {
                throw error;
              } else {
                // 在自动支付失败后，给予用户替换卡号的机会
                this.cardError.show = true;
                this.cardError.message =
                  error.msg || "An unexpected error occurred.";
              }
            }
          } else {
            // 发现是降级操作，则直接弹出降级提示
            this.downgradeText = `You will be downgraded to “${
              this.planName
            } Plan” in your next payment period on ${moment(
              this.user.plan.currentPeriodEnd
            ).format("MMM DD, YYYY")}.`;
            this.showDowngradeMenu = true;
          }
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 弹出层订阅按钮点击回调事件
     */
    async subscribeClick(type) {
      this.$loading.show();
      try {
        if (type === "paypal") {
          await this.paypalSubscribe();
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
      if (type !== "paypal") {
        await this.stripeSubscribe();
      }
    },
    /**
     * paypal弹出层点击确认回调
     */
    async paypalSubscribe() {
      // 2018.11.5 新增sale判断，如果是直接跳入该页面，则存在plan字段，sale为true，平时为false
      const url = await paypalUrl({
        id: this.form.id,
        sale: this.$route.query.plan_id !== undefined,
        type: this.$route.query.type,
      });
      // 保存当前订阅类型
      this.$store.commit(PAY_PAGE_TYPE, this.$route.params.name);
      this.$store.commit(PAY_PAGE_TYPE_ID, this.form.id);
      // 隐藏弹出
      this.showPaypalModal = false;
      window.location.href = url;
    },
    /**
     * PayPal按钮点击事件
     */
    async payPalClick() {
      // 2018.12.26 新增paypal判断不能输入优惠码
      if (this.form.coupon) {
        this.showCouponCancelModal = true;
      } else {
        this.showPaypalModal = true;
        this.payType = "paypal";
      }
    },
    /**
     * stripe 按钮点击事件
     */
    async stripeClick() {
      this.showPaypalModal = true;
      this.payType = "stripe";
    },
    /**
     * 切换付费计划
     * @param item 计划数据
     */
    switchPlan(item) {
      this.form.id = item.id;
    },
    /**
     * problem点击事件
     */
    payProblemClick() {
      window.open(process.env.CONTACT_US, "_blank");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== "PaymentSuccessPage") {
        vm.$store.commit(BEFORE_PAY_PAGE, from.name);
      }
      // 通过 `vm` 访问组件实例
      if (from.name === "MyPlanPage" || from.name === "ActivePage") {
        vm.backPageNum = -1;
      } else {
        vm.backPageNum = -2;
      }
      vm.form.name = "";
    });
  },
};



// WEBPACK FOOTER //
// ./src/pages/payment/Subscription.vue